import React from 'react';
import { View, colors, Grid, Page, GridColumn } from '@fairygodboss/ui';
import {
    AboveTheFoldLink,
    ContentInfo,
    ContentTitle,
    MainArticleBody,
    SocialCTA,
} from './components';
import { useCommunityContent } from '../CommunityContentContext';

export const ContentBody = () => {
    const { backgroundHeight } = useCommunityContent();

    return (
        <View
            suppressHydrationWarning
            display="flex"
            width="100%"
            color={colors.neutral[100]}
            background={`linear-gradient(to bottom, #F6F2FE ${backgroundHeight}px, white 0%);`}
            css={{
                fontFamily: 'Open Sans',
            }}
        >
            <View
                display="flex"
                width="100%"
                flexDirection="column"
                alignItems="center"
            >
                <Page width="100%">
                    <Grid
                        maxWidth="1176px"
                        pl={{ _: '16px', md: '24px', lg: '8px' }}
                        pr={{ _: '16px', md: '0px', lg: '16px' }}
                        justifyContent={{
                            _: 'left',
                            sm: 'center',
                            md: 'left',
                            lg: 'right',
                        }}
                    >
                        <GridColumn
                            size={{ xs: 12, sm: 9, md: 12, lg: 11 }}
                            pl="100px"
                            css={{
                                paddingLeft: '0px',
                                paddingRight: '0px',
                            }}
                        >
                            <AboveTheFoldLink
                                communityContext={useCommunityContent}
                            />
                            <ContentTitle
                                communityContext={useCommunityContent}
                            />
                            <ContentInfo />
                            <MainArticleBody />
                            <SocialCTA communityContext={useCommunityContent} />
                        </GridColumn>
                    </Grid>
                </Page>
            </View>
        </View>
    );
};

ContentBody.displayName = 'ContentBody';
